import { render, staticRenderFns } from "./role-management.vue?vue&type=template&id=3ec94d1e&scoped=true&"
import script from "./role-management.vue?vue&type=script&lang=js&"
export * from "./role-management.vue?vue&type=script&lang=js&"
import style0 from "./role-management.vue?vue&type=style&index=0&id=3ec94d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec94d1e",
  null
  
)

export default component.exports